import React from 'react';

const partnerLogos = [
  { src: 'finland.png', alt: 'Finland Embassy' },
  { src: 'sweden.png', alt: 'Sweden Embassy' },
  { src: 'andelllla.png', alt: 'Andela' },
  { src: 'eu pic.png', alt: 'European Union' },
  { src: 'google.png', alt: 'Google' },
  { src: 'download.png', alt: 'Download' },
  { src: 'siili.png', alt: 'Siili' },
  { src: 'dpixel.png', alt: 'DPixel' },
  { src: 'stimul.png', alt: 'Stimul' },
  { src: 'porto.png', alt: 'Porto' }
];

function Partners() {
  const base = `${process.env.PUBLIC_URL}/assest/img`;
  const logos = [...partnerLogos, ...partnerLogos];
  return (
    <section className="section partners" id="partners">
      <div className="section-container partners-container">
        <p className="eyebrow">OUR PARTNERS</p>
        <h2 className="section-title">We are honored to have worked with</h2>
        <div className="partners-carousel">
          <div className="partners-track">
            {logos.map((logo, idx) => {
              const encoded = encodeURIComponent(logo.src);
              return (
                <div className="partner-logo" key={`${logo.src}-${idx}`}>
                  <img src={`${base}/${encoded}`} alt={logo.alt} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Partners;


